import SecurityController from 'controller/securitycontroller.js';
import logger from '@/plugins/logger';

// initial state
const state = {
  securitylevels: [],
  sessionExpired: false,
  queue: [],
  isSupportVerified: null
};

// getters
const getters = {
  getSecurityById: (state) => (code) => {
    return state.securitylevels.filter(x => x.ID === code.ID && x.Action === code.Action);
  },
  isAuthorized: (state, getters) => (codes) => {
    let total = [];
    for (let code of codes) {
      total.push(...getters.getSecurityById(code));
    }
    let notgranted = total.filter(x => x.Grant === false);
    return (notgranted.length === 0);
  },
  isSupportVerified: state => {
    return state.isSupportVerified;
  }
};

// actions
const actions = {
  authorize (context, resourcecodes) {
    return new Promise(async (resolve, reject) => {
      let torequest = [];

      for (let code of resourcecodes) {
        let existing = context.getters.getSecurityById(code);
        if (existing.length === 0) {
          torequest.push(code);
        }
      }

      // all security items known
      if (torequest.length === 0) {
        logger.log('is authorized', context.getters.isAuthorized(resourcecodes));
        return resolve(context.getters.isAuthorized(resourcecodes));
      }

      context.commit('addQueue', torequest);

      let controller = new SecurityController();
      controller.linkApiController(context.rootGetters.api);
      await controller.GetAuthorization(torequest).then(result => {
        context.commit('updateSecurity', result);
      }).catch(err => {
        console.error(err);
        reject(err);
      });

      return resolve(context.getters.isAuthorized(resourcecodes));
    });
  },
  isSupportVerified (context) {
    return new Promise(async (resolve, reject) => {
      if (context.getters.isSupportVerified !== null) {
        return resolve(context.getters.isSupportVerified);
      }
      let controller = new SecurityController();
      await controller.IsSupportVerified().then(result => {
        context.commit('setIsSupportVerified', result);
      }).catch(err => {
        console.error(err);
        reject(err);
      });
      return resolve(context.getters.isSupportVerified);
    });
  }
};

// mutations
const mutations = {
  updateSecurity (state, result) {
    state.securitylevels.push(...result);
  },
  sessionExpired (state, value) {
    state.sessionExpired = value;
  },
  addQueue (state, items) {
    state.queue.push(...items);
  },
  setIsSupportVerified (state, value) {
    state.isSupportVerified = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
